export const routes = [
  // 'Dashboard',
  // "Report",
  // "Tags Management",
  "Campaigns",
  "Prospects",
  "Version History",
  // 'Apollo Messages',
  "Files",
];
export const codelabsRoutes = [
  // 'Dashboard',
  // "Report",
  // "Tags Management",
  "Campaigns",
  "Users",
  // "Apollo Messages",
  "Files",
];
export const UserDataColumns = [
  "firstName",
  "lastName",
  "email",
  // 'state',
  // 'gender',
  // 'country',
  // 'createdAt',
  // 'blackListed',
  // 'redFlagged',
  // 'total',
  "totalCampaigns",
  "totalSent",
  "totalOpens",
  "totalClicks",
  "totalUnsubScribed",
  "totalBlocked",
  "openRate",
  "totalBounced",
];
export const fileMappingOptions = [
  { name: "organization", label: "Company" },
  { name: "organizationId", label: "Company ID" },
  { name: "contact", label: "Contact" },
  { name: "country", label: "Country" },
  { name: "city", label: "City" },
  { name: "department", label: "Department" },
  { name: "email", label: "Email" },
  { name: "emailStatus", label: "Email Status" },
  { name: "firstName", label: "First Name" },
  { name: "fullName", label: "Full Name" },
  { name: "lastName", label: "Last Name" },
  { name: "emailName", label: "Generic Name" },
  { name: "emailCompany", label: "Generic Company Name" },
  { name: "gender", label: "Gender" },
  { name: "industry", label: "Industry" },
  { name: "isVerified", label: "Is Verified" },
  { name: "jobTitle", label: "Job Title" },
  { name: "language", label: "Language" },
  { name: "leadStatus", label: "Lead Status" },
  { name: "linkedIn", label: "Company LinkedIn" },
  { name: "messageBucket", label: "Message Bucket" },

  { name: "personId", label: "Person Id" },
  { name: "relationship", label: "Delete Tag" },
  { name: "source", label: "Source" },
  { name: "specialMessageDaniel", label: "Lead Type" },
  { name: "state", label: "State" },
  { name: "tierLevel", label: "Tier Level" },
  { name: "tierNumber", label: "Tier Number" },
  { name: "tierType", label: "Tier Type" },
];

export const dynamicUserColumns = [
  { name: "organization", label: "Company" },
  { name: "organizationId", label: "Company ID" },
  { name: "contact", label: "Contact" },
  { name: "country", label: "Country" },
  { name: "city", label: "City" },
  { name: "department", label: "Department" },
  { name: "email", label: "Email" },
  { name: "emailStatus", label: "Email Status" },
  { name: "emailName", label: "Generic Name" },
  { name: "emailCompany", label: "Generic Company Name" },
  { name: "firstName", label: "First Name" },
  { name: "fullName", label: "Full Name" },
  { name: "gender", label: "Gender" },
  { name: "industry", label: "Industry" },
  { name: "isVerified", label: "Is Verified" },
  { name: "jobTitle", label: "Job Title" },
  { name: "language", label: "Language" },
  { name: "lastName", label: "Last Name" },
  { name: "leadStatus", label: "Lead Status" },
  { name: "linkedIn", label: "Company LinkedIn" },
  { name: "messageBucket", label: "Message Bucket" },

  { name: "personId", label: "Person Id" },
  { name: "relationship", label: "Delete Tag" },
  { name: "source", label: "Source" },
  { name: "specialMessageDaniel", label: "Lead Type" },
  { name: "state", label: "State" },
  { name: "tierLevel", label: "Tier Level" },
  { name: "tierNumber", label: "Tier Number" },
  { name: "tierType", label: "Tier Type" },
];

// export const comparisonHeader = ["FIRSTNAME", "LASTNAME", "CONTACT", "COMPANY"];
export const comparisonHeader = [
  "FIRST NAME",
  "LAST NAME",
  // 'TITLE',
  "EMAIL",
  "EMAIL VERIFIED",
  "EMAIL STATUS",
  "EMAIL LAST VERIFIED",
  // 'SENIORITY',
  // 'DEPARTMENT',
  // 'CONTACT',
  // 'WORK DIRECT PHONE',
  // 'HOME PHONE',
  // 'COMPANY PHONE',
  // 'CORPORATE PHONE',
  // 'INDUSTRY',
  // 'COUNTRY',
  // 'COMPANY',
  // 'COMPANY ADDRESS',
  // 'WEBSITE',
  // 'COMPANY LINKEDIN',
  // 'ANNUAL REVENUE',
  // 'EMAIL SENT',
  // 'EMAIL OPENED',
  // 'EMAIL BOUNCED',
  // 'EMAIL REPLIED',
  "VERIFIED",
  "BLACKLISTED",
  "RED FLAGGED",
  "Created AT",
  // 'File ID'
];

export const Header = {
  "FIRST NAME": "firstName",
  "LAST NAME": "lastName",
  // TITLE: 'title',
  EMAIL: "email",
  "EMAIL VERIFIED": "verified",
  "EMAIL STATUS": "state",
  "EMAIL LAST VERIFIED": "lastVerified",
  // SENIORITY: 'seniority',
  // DEPARTMENT: 'department',
  // CONTACT: 'contact',
  // 'WORK DIRECT PHONE': 'workDirectPhone',
  // 'HOME PHONE': 'homePhone',
  // 'COMPANY PHONE': 'companyPhone',
  // 'CORPORATE PHONE': 'corporatePhone',
  // INDUSTRY: 'industry',
  // COUNTRY: 'country',
  // COMPANY: 'company',
  // 'COMPANY ADDRESS': 'companyAddress',
  // WEBSITE: 'website',
  // 'COMPANY LINKEDIN': 'companyLinkedIn',
  // 'ANNUAL REVENUE': 'annualRevenue',
  // 'EMAIL SENT': 'emailSent',
  // 'EMAIL OPENED': 'emailOpened',
  // 'EMAIL BOUNCED': 'emailBounced',
  // 'EMAIL REPLIED': 'emailReplied',
  VERIFIED: "isVerified",
  BLACKLISTED: "blackListed",
  "RED FLAGGED": "isRedFlagged",
  "CREATED AT": "createdAt",
  // 'UPDATED AT': 'updatedAt',
  // 'FILE ID': 'fileId'
};

export const dashboardTableHeader = ["DATE UPLOADED", "FILE NAME", ""];
export const filesTableHeader = [
  "Date Uploaded",
  "File Name",
  "Progress",
  "Status",
  " ",
];

export const saveFiltersTableHeader = ["Created At", "Title", "ACTIONS"];

export const CampaignHeader = [
  // 'ID',
  "Campaign Title",
  "Campaign Subject",
  "Campaign Owner",
  "Industry",
  "Approved",
  "Start Date",
  "End Date",
  "Actions",
];

export const CampaignSubHeader = [
  "Total Processed",
  "Total Sent",
  "Total Opened",
  "Total Replied",
  "Total Clicks",
  "Open Rate",
  "Click Rate",
  "Replied Rate",
];

export const campaignDetailsHeader = [
  "First Name",
  "Last Name",
  "User Email",

  "Campaign ID",
  "Campaign Title",
  "Campaign Subject",
  "Started At",
];

export const userSelectionHeader = [
  // 'id',
  "First Name",
  "Last Name",
  "Email",
  "Email Status",
  // 'Contact',
  "Blacklisted",
  // "Title",
  // 'Company',
  "Red Flagged",
  "Verified",
  // "Company Address",
  // "Department",
  // "Seniority",
  "Campaigns",
  "Sent",
  "Opens",
  "Clicks",
  "Open rate",
  // "click rate"
];
export const campaignUserHeader = [
  // 'id',
  "First Name",
  "Last Name",
  "Email",
  "Email Status",
  "BlackListed",
  "Red Flagged",
  "Verified",
  // 'Company Address',
  // 'Department',
  // 'Seniority',
  "Campaigns",
  // "Sent",
  // "Opens",
  // "Clicks",
  // "Open rate",
  // "click rate"
];

export const userCampaignStats = ["campaign Title", "Event", "Event Time"];

// Event render priority for campaign stats expanded rows
// Lower number = rendered earlier
export const campaignEventRenderPriority = {
  processed: 1,
  deferred: 2,
  delivered: 3,
  bounce: 4,
  open: 5,
  click: 6,
  unsubscribe: 7,
};
